export type BasePortalSuccessResponse = {
  result: 'success';
  message: string;
};
export type BasePortalErrorResponse = {
  result: 'error';
  message: string;
};

export type BasePortalResponse = {
  result: 'error' | 'success';
  message: string;
};

export const isPortalResponseSuccess = <R>(
  response: any
): response is R & BasePortalSuccessResponse => {
  return response?.result === 'success';
};

export const isPortalResponseError = <R>(
  response: any
): response is R & BasePortalErrorResponse => {
  return response?.result === 'error';
};
